export const ButtonVariants = {
    ALTERNATIVE: 'alternative',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TRANSPARENT: 'transparent',
};

export default ButtonVariants;
